import { FC } from 'react';
import { twJoin } from 'tailwind-merge';

import { Page } from '@/components/Page';
import { PAGE_MARGIN_CLASSNAME } from '@/components/PageLayout';
import { ResourceFilterPanel } from '@/components/ResourceFilterPanel/ResourceFilterPanel';
import { SearchResultsContents } from './components/SearchResultsContents';

export const SearchPage: FC = () => {
  return (
    <Page title={'Search Results'} pageType="searchResults">
      <div className="flex h-full">
        <span className={twJoin('flex-1 overflow-y-auto', PAGE_MARGIN_CLASSNAME)}>
          <SearchResultsContents />
        </span>
        <span className="flex-0 h-full overflow-y-auto">
          <ResourceFilterPanel />
        </span>
      </div>
    </Page>
  );
};
